import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { Alert, Avatar, Button, Chip, CircularProgress, Fab, FormHelperText, Grid2, IconButton, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select, Stack, Switch, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import Grid from '@mui/material/Grid2';
import './home.sass'
import { useForm, SubmitHandler } from 'react-hook-form';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import { utils, read, writeFile } from 'xlsx';
import CheckIcon from '@mui/icons-material/Check';

import {Scanner} from '@yudiel/react-qr-scanner';

import FormControl, { useFormControl } from '@mui/material/FormControl';

import WifiOffOutlinedIcon from '@mui/icons-material/WifiOffOutlined';
import WifiOutlinedIcon from '@mui/icons-material/WifiOutlined';

import DateRangePicker from '@wojtekmaj/react-daterange-picker';

import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

import SearchIcon from '@mui/icons-material/Search';


import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import StarIcon from '@mui/icons-material/Star';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';

import TextField from '@mui/material/TextField';
import UserCard from '../Components/UserCard/UserCard';
import { Check, CircleNotificationsOutlined, DateRangeRounded } from '@mui/icons-material';

import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

type ValuePiece = Date | null;

type Value = ValuePiece | [ValuePiece, ValuePiece];

import { DataGrid, GridRowsProp, GridColDef } from '@mui/x-data-grid';
import {apiEvent, apiTickets, refreshToken} from '../Components/ApiCall';

import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined';
import './internalCheckins.sass';

type FormData = {
  search: string;
};

const dateFormatter = (dateTime:string)=>{

  const options:any = {
    year: '2-digit',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: '2-digit'
  };

  const oldDate = new Date(dateTime)
  return oldDate.toLocaleDateString('pt-BR', options).split(',').join(' ')
}

const InternalCheckins = () => {

  const processRowUpdate = (after:any, before:any) => {
    return after
  }



  const { register, handleSubmit, formState: { errors }, setValue } = useForm<FormData>();
  let _remove_biometry_times = 0
  const [notFound, setNotFound] = useState(false);

  const onSubmit: SubmitHandler<FormData> = async (data) => {
    
    setSuccess(false);
    setLoading(true);

    let response:any
    let typeParam = searchType === 'token' ? 'token' : 'document';

    try{

      if(checkInSearchType === 'cards'){
        response = await apiTickets.get(`/http://tickets.bepass.app/card/all/${selectedEvent}?pageSize=9999999`);
      }else{
        response = await apiTickets.get(`/tickets/checkin/logs/search?id=${data.search}&type=${typeParam}&page=1`);
      }

      if (response?.data?.tickets?.length === 0) {
        setNotFound(true); 

        setTimeout(() => {
          setNotFound(false)
        }, 3000);
        return false
      } 
  
      setTicketLogList(response?.data?.tickets)
      setVai(false)
    
    }catch(error){
      const _temp_can_refresh = await refreshToken()
      if(_remove_biometry_times > 2){
        console.error(error);
          alert('Sua sessão expirou. Por favor, faça o login novamente')
          window.location.href = '/'
      }else{
        _remove_biometry_times++
        if(_temp_can_refresh){
          onSubmit(data)
        }else{
          const _temp_company = sessionStorage.getItem('selected_cmp') || ''
          sessionStorage.clear()
          if(_temp_company){
            sessionStorage.setItem('selected_cmp', _temp_company)
          }
            alert('Sua sessão expirou. Por favor, faça o login novamente')
            window.location.href = '/'
        }
      }
    }
  };

  const [rola, setRola] = useState<any>([])
  const [vai, setVai] = useState<boolean>(true)

  const [checkInSearchType, setCheckInSearchType] = useState<any>('default')
  const [selectedEvent, setSelectedEvent] = useState<any>('c4b722a8-4376-4f0f-9d12-b8175a9ef100')

  const [searchType, setSearchType] = useState<'token' | 'cpf'>('token')
  
  const [deviceSummary, setDeviceSummary] = useState<any>({
      firmware_ok: 0,
      firmware_waiting: 0,
      firmware_nok: 0
  })


  const [ticketLogList, setTicketLogList] = useState<any>()

    const handleProcessRowUpdateError = (item:any) => {
      console.log(item)
      return item
    }

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [openScaner, setOpenScaner] = React.useState(false);
    const handleOpenScaner = () => {setScanSession(1);setOpenScaner(true)};
    const handleCloseScaner = () => {setScanSession(1);setOpenScaner(false);};
    const [scanSession, setScanSession] = React.useState(1);
    
    
    const [loading, setLoading] = React.useState(false);
    const [success, setSuccess] = React.useState(false);
    const timer = React.useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

let _fetch_times = 0
const fetchData = async (eventId:any = selectedEvent) => {
  try {

    setSelectedEvent(eventId)
    let response:any;
    if(checkInSearchType === 'cards'){
      response = await apiTickets.get(`/card/all/${eventId}?pageSize=9999999`);
    }else{
      response = await apiTickets.get('/tickets/checkin/logs/search?&page=1&pageSize=9999999');
    }

    console.log(response.data);

    setTicketLogList(response.data?.tickets)
    setVai(false)

    const _temp_firmware_summary = {
      firmware_ok: 0,
      firmware_waiting: 0,
      firmware_nok: 0
  }


  const _temp_cmp = sessionStorage.getItem('company_slug') || null;
  let _temp_bebox_version = '2.05'
    if(_temp_cmp === 'santos') {
      _temp_bebox_version = '2.08'
    } else if(_temp_cmp === 'gremio'){
    _temp_bebox_version = '2.08'
    }else if(_temp_cmp === 'fonte-nova'){
      _temp_bebox_version = '2.13'
    }else if(_temp_cmp === 'dunas'){
      _temp_bebox_version = ' 2.37'
    }


    setVai(false)
    setDeviceSummary(_temp_firmware_summary)



  const companyId = sessionStorage.getItem('company_id') ||  'na'
  const eventResponse = await apiEvent.get(`/event/group/events/company/${companyId}`);
  // const activeEvents = response.data.events.filter((item:any) => item.isActive)
  setEventList(eventResponse.data.events)
  console.log('ocr', eventResponse.data.events)

  } catch (error) {
    const _temp_can_refresh = await refreshToken()
    if(_fetch_times > 3){
      console.error(error);
      // alert('Sua sessão expirou. Por favor, faça o login novamente')
      // window.location.href = '/'
    }else{
      _fetch_times++
      if(_temp_can_refresh){
        fetchData()
      }else{
        const _temp_company = sessionStorage.getItem('selected_cmp') || ''
        sessionStorage.clear()
        if(_temp_company){
          sessionStorage.setItem('selected_cmp', _temp_company)
        }
        // alert('Sua sessão expirou. Por favor, faça o login novamente')
        // window.location.href = '/'
      }
    }
  }
};

  const downloadReport = async () => {


// const reportFile = await userList.map((item:any) => {
//   return {
//     tem_biometria: item.biometry === 'yes' ? 'sim':'não',
//     onboarding: `https://ingresse.bepass.com.br?token=?${item.token}`,
//     id_sessao: item.session_id,
//     documento: item.document,
//     nome: item.user_name,
//     ingresso: item.user_ticket
//   }
// })
    const worksheet = utils.json_to_sheet(ticketLogList);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, 'relatorio');
    writeFile(workbook, `relatorio-log-acesso.xlsx`);
  }


  const handleChange = (event:any) => {
    setCheckInSearchType(event.target.value);
    console.log(event.target.value)
  }


const columns: GridColDef<any>[] = [
  { 
    field: 'token',
    headerName: 'Hash',
    width: 250
  },{ 
    field: 'checkInDate',
    headerName: 'Data/hora',
    width: 230,
    renderCell: (params) => dateFormatter(params.value)
  },{ 
    field: 'checkInDevice',
    headerName: 'Device',
    width: 110
  },{ 
    field: 'checkInType',
    headerName: 'Tipo',
    width: 90,
  },{ 
    field: 'requestType',
    headerName: 'Tipo de Requisição',
    width: 150,
  },{ 
    field: 'status',
    headerName: 'Status',
    width: 200,
  }
];


const columnsMobile: GridColDef<any>[] = [
  {
    field: 'bebox_version',
    headerName: 'Versão bebox',
    width: 80,
    editable: true
  },
  { 
    field: 'device_name',
    headerName: 'Device',
    width: 140,
    editable: true,
    renderCell: (params) => {
      return <span className='single-status'>
        {params.row.healthCheck ? (
          
          params.row.healthCheck.its === 'down' ? (
            <WifiOffOutlinedIcon className='icon-inactive' />
          ):(
            <WifiOutlinedIcon className='icon-active' />
          )
        ):(
          <WifiOffOutlinedIcon className='icon-inactive' />
        )}
      {params.row.healthCheck?.totem_id || `bebox_${params.row.device_name}`}
      </span>    },
  },{ 
    field: 'device_ip',
    headerName: 'Device IP',
    width: 140,
    editable: true,
  },{ 
    field: 'bebox_name',
    headerName: 'tag',
    width: 140,
    editable: true,
  }
];


useEffect(() => {
  fetchData()
}, [])

const [eventList, setEventList] = useState<any>([])

  return (
    <Box>


{eventList && eventList.length > 0 && (
   <Box className="event-select">
   <FormControl  fullWidth>
           <InputLabel id="demo-simple-select-label">Escolher</InputLabel>
           <Select
             labelId="demo-simple-select-label"
             id="demo-simple-select"
             // value={age}
             label="Escolher"
             defaultValue={eventList[0].id}
             onChange={(e) => {fetchData(e.target.value)}}
           >
              {Array.isArray(eventList) && eventList.map((item: any, index: any) => (
                <MenuItem key={index} value={item.id}>
                  [{item.events?.[0]?.externalId || 'Sem ID'}] {item.name}
                </MenuItem>
              ))}
           </Select>
         </FormControl>
   </Box>
)}
      <Box className="header-with-button">
        <Typography variant="subtitle1" component="h2">
          Logs Acesso
        </Typography>

      <Box className="header-with-search">
{
  checkInSearchType === 'default' && (
    <form className='log-search-form' onSubmit={handleSubmit(onSubmit)}>
      <FormControl fullWidth margin="normal">
        <InputLabel id="search-type-label">Tipo</InputLabel>
        <Select
          labelId="search-type-label"
          label="Tipo"
          value={searchType}
          onChange={(e) => {
            setSearchType(e.target.value as 'token' | 'cpf')
            setValue('search', '') 
          }}
        >
          <MenuItem value="token">Ingresso</MenuItem>
          <MenuItem value="cpf">CPF</MenuItem>
        </Select>
      </FormControl>

      <TextField
        label={searchType === 'token' ? 'Ingresso' : 'CPF'}
        {...register("search", {
          required: `${searchType === 'token' ? 'Ingresso' : 'CPF'} é obrigatório`,
        })}
        error={!!errors.search}
        helperText={errors.search?.message}
        fullWidth
        margin="normal"
      />

      <Button
        variant="contained"
        type="submit"
        className="besafe-select-form-button"
      >
        Pesquisar
      </Button>
    </form>
  )}
       
        <Button variant="outlined" onClick={() => fetchData()}>Recarregar</Button>
        <Button variant="contained" onClick={() => downloadReport()}>Baixar</Button>
        </Box>

      </Box>

      {notFound && (
        <Alert severity="info" color="warning">
          Não encontrado
        </Alert>
      )}


      <Box className="data-table-wrapper">
      
<DataGrid
        sx={{ display: { xs: 'none', md: 'block' }}}
        rows={ticketLogList}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 20,
            },
          },
        }}
        pageSizeOptions={[20]}
        checkboxSelection
        disableRowSelectionOnClick
        processRowUpdate={(updatedRow, originalRow) =>
          processRowUpdate(updatedRow, originalRow)
        }
        onProcessRowUpdateError={handleProcessRowUpdateError}
        loading={vai}
        slotProps={{
          loadingOverlay: {
            variant: 'linear-progress',
            noRowsVariant: 'skeleton',
          },
        }}
      />


      {/* enhance this */}
      <DataGrid
        sx={{ display: { xs: 'block', md: 'none' }}}
        rows={rola}
        columns={columnsMobile}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 20,
            },
          },
        }}
        pageSizeOptions={[20]}
        disableRowSelectionOnClick
        processRowUpdate={(updatedRow, originalRow) =>
          processRowUpdate(updatedRow, originalRow)
        }
        onProcessRowUpdateError={handleProcessRowUpdateError}
        loading={vai}
        slotProps={{
          loadingOverlay: {
            variant: 'linear-progress',
            noRowsVariant: 'skeleton',
          },
        }}
      />
      </Box>
    </Box>
  )
};

export default InternalCheckins;